import React from 'react';
import { S3UploadButton } from '../uploadButton';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router';
import ImportProcess from './model';
import { Card } from '@weezevent/nacre';

import ButtonGroup from './stateless/buttonGroup';
import ShowAnalysis from './stateless/analysis';

import WeezAnimation from '../../images/weez-logo.gif';

export default function ImportRender({
    filename,
    step,
    titles,
    subtitles,
    abortWarning,
    onFileSelected,
    onFileUploaded,
    onReset,
    onTrigger,
    importProcess,
    authorizationURL,
    fetch,
    results: ResultsComponent,
    validationError
}) {
    const [showDetails, setDetails] = React.useState(false);
    const toggleDetails = React.useCallback(() => setDetails(!showDetails), [showDetails]);

    return (
        <div className="import-controller">
            {step === 'import-process-processing' && abortWarning ? <Prompt message={abortWarning} /> : null}
            <Card.FormStep title={titles['initial']} subtitle={subtitles['initial']} onCardEdit={onReset} state={['initial', 'file-uploading'].includes(step) ? 'open' : 'done'}>
                <div>
                    {step === 'initial' || step === 'file-uploading' ? (
                        <div className="container-button">
                            <S3UploadButton
                                fetch={fetch}
                                authorizationURL={authorizationURL}
                                onFileUploaded={onFileUploaded}
                                onFileSelected={onFileSelected}
                                acceptedFileExtensions={['.xlsx']}
                                icon={'upload'}
                            />
                        </div>
                    ) : null}
                    {filename ? (
                        <div className="name-file">
                            <span>{filename}</span>
                        </div>
                    ) : null}
                </div>
            </Card.FormStep>

            <Card.FormStep
                title={titles['import-process-confirm']}
                subtitle={subtitles['import-process-confirm']}
                state={['import-process-confirm', 'import-process-validating'].includes(step) ? 'open' : step === 'import-process-done' ? 'done' : 'closed'}
                onModify={onReset}
            >
                <div>
                    {step === 'import-process-confirm' && (
                        <React.Fragment>
                            <ShowAnalysis importProcess={importProcess} validationError={validationError} showDetails={showDetails} toggleDetails={toggleDetails} />
                            <ButtonGroup onReset={onReset} onTrigger={onTrigger} />
                        </React.Fragment>
                    )}
                    {step === 'import-process-validating' && (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img alt="Weezevent Animation" style={{ maxWidth: '100px' }} src={WeezAnimation} />
                        </div>
                    )}
                </div>
            </Card.FormStep>

            <Card.FormStep title={titles['import-process-done']} subtitle={subtitles['import-process-done']} state={step === 'import-process-done' ? 'open' : 'closed'}>
                <div>
                    {ResultsComponent ? <ResultsComponent importProcess={importProcess} /> : null}
                    <ShowAnalysis importProcess={importProcess} validationError={validationError} showDetails={showDetails} toggleDetails={toggleDetails} />
                    <ButtonGroup onNew={onReset} />
                </div>
            </Card.FormStep>
        </div>
    );
}

ImportRender.propTypes = {
    step: PropTypes.oneOf(['initial', 'file-uploading', 'import-process-validating', 'import-process-confirm', 'import-process-processing', 'import-process-done']).isRequired,
    titles: PropTypes.object,
    subtitles: PropTypes.object,
    abortWarning: PropTypes.string,
    onFileSelected: PropTypes.func.isRequired,
    onFileUploaded: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    fetch: PropTypes.func,
    onTrigger: PropTypes.func.isRequired,
    filename: PropTypes.string.isRequired,
    importProcess: PropTypes.instanceOf(ImportProcess),
    results: PropTypes.elementType,
    validationError: PropTypes.elementType,
    authorizationURL: PropTypes.string.isRequired
};
